var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"custom-btn elevation-0",class:[_vm.color.text],attrs:{"loading":_vm.loading,"color":_vm.color.bg},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-btn',_vm.options,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }